import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Dashboard from "./pages/Dashboard"
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";

import IntelliBill from "./pages/IntelliBill";

import ClaimApproval from "./pages/ClaimApproval";

import ClaimStatus from "./pages/ClaimStatus";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLogs from "./pages/TransactionLogs";

import PostingPayments from "./pages/PostingPayments";

import TabNavigation from "./components/TabNavigation";

import LoginLocation from "./components/LoginLocation";
import PatDasboardNavigation from "./components/PatDashboardNavigation";

import Remittance from "./pages/Remittance";

import Encounter from "./pages/Encounter";
import ClaimMacro from "./pages/ClaimMacro";

import SuperBill from "./pages/Superbill";
import GeneralDocuments from "./pages/GeneralDocuments";
import PatientInsTab from "./components/PatientInsTab";

import PatientTrackerTabs from "./components/PatientTrackerTabs";
import InsPaymentReport from "./pages/InsPaymentReport";
import EditCpt from "./pages/EditCpt";
import AgingReport from "./pages/AgingReport";
import ARClaimDetails from "./pages/ARClaimDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import PatientContacts from "./components/PatientContacts";
import CPTReport from "./pages/CPTReport";
import DeniedDashboardPreview from "./pages/DeniedDashboardPreview";

import PatDashboard from "./components/PatDashboard";
import LabBilling from "./pages/LabBilling";
import FaxDocuments from "./pages/FaxDocuments";
import PatientStatementsWorkflow from "./pages/PatientStatementsWorkflow";
import APIDebugTest from "./pages/APIDebugTest";
import { useSelector } from "react-redux";
import useAuthAndInactivity from "./common/hook/useAuthAndInactivity";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import RemiWidget from "./features/assistant";
import { RemiContextProvider } from "./features/assistant/RemiContext";
import RemiCoverageCheck from "./features/assistant/diagnostics/CoverageCheck";
import ScreenNotFound from "./components/ScreenNotFound";
const standaloneRoutes = ["/BillerDashboard", "/DenialManagement", "/BillerPatients", "/BillerClaimApproval", "/BillerInsuranceVerification", "/BillerPatientDetail", "/BillerClaimReview", "/BillerClaimPosting", "/BillerResubmit"];

const App = () => {
  const userData = useSelector((state) => state.user.user);
  const userPracticeID = userData ? userData.practiceID : null;
  const userId = userData ? userData.userID : null;
  const { logout } = useAuthAndInactivity(userData, userPracticeID, userId);
    const location = useLocation();
   const isStandalone = standaloneRoutes.some((r) => location.pathname === r || location.pathname.startsWith(r + "/"));
   const isLocationsPage = location.pathname === "/locations";
   // The Navbar (which holds the logout) is hidden on standalone routes and the
   // locations page. Show a floating logout there so it's available on all pages.
   const showFloatingLogout = userData && (isStandalone || isLocationsPage) && location.pathname !== "/DenialManagement";

  // Sidebar open state lives here, not in Navbar: .hv-shell needs the sidebar
  // and the routed page to be sibling flex children so opening the menu PUSHES
  // the page instead of covering it. The hamburger stays in Navbar and calls
  // toggleSidebar via prop.
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  // Escape closes the menu from anywhere.
  useEffect(() => {
    if (!isSidebarOpen) return undefined;
    const onKeyDown = (e) => { if (e.key === "Escape") setIsSidebarOpen(false); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isSidebarOpen]);

  const showShell = userData && !isStandalone;

  return (
    <RemiContextProvider>
      {showShell && (
        <Navbar handleLogout={logout} toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      )}

      {showFloatingLogout && (
        <button
          className="global-logout-btn"
          onClick={logout}
          title="Logout"
          aria-label="Logout"
        >
          <FontAwesomeIcon icon={faRightFromBracket} />
        </button>
      )}

      <ToastContainer />

      {/* Remi - AI billing assistant. Renders on every authenticated page,
          including standalone biller routes. Self-hides when logged out.
          Kept outside .hv-shell on purpose: remi.css positions it fixed, so it
          must not become a flex child of the shell row. */}
      <RemiWidget />

      <div className={showShell ? `hv-shell${isSidebarOpen ? " is-open" : ""}` : undefined}>
        {showShell && (
          <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} closeSidebar={closeSidebar} />
        )}

        <div className={showShell ? "hv-shell__main" : undefined}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/locations"
          element={<ProtectedRoute element={<LoginLocation />} />}
        />
       
          <Route
          path="/Billingdasboard"
          element={<ProtectedRoute element={<Dashboard/>} />}
        />
       
        <Route
          path="/IntelliBill"
          element={<ProtectedRoute element={<IntelliBill/>} />}
        />
      
        <Route
          path="/claim-approval"
          element={<ProtectedRoute element={<ClaimApproval/>} />}
        />
          <Route
          path="/PatientContacts/:id/*"
          element={<ProtectedRoute element={<PatientContacts />} />}
        />
       
         <Route
          path="/Lab-Billing"
          element={<ProtectedRoute element={<LabBilling/>} />}
        />
      
        <Route
          path="/ClaimStatus/:InsID"
          element={<ProtectedRoute element={<ClaimStatus/>} />}
        />
        <Route
          path="/ClaimStatus"
          element={<ProtectedRoute element={<ClaimStatus/>} />}
        />
      
        <Route
          path="/new-encounter"
          element={<ProtectedRoute element={<Encounter />} />}
        />
        <Route
          path="/new-encounter/:id"
          element={<ProtectedRoute element={<Encounter />} />}
        />
      
         <Route
          path="/Upload-RemittanceFiles"
          element={<ProtectedRoute element={<Remittance />} />}
        />
       
        <Route
          path="/posting-payments"
          element={<ProtectedRoute element={<PostingPayments />} />}
        />
        <Route
          path="/MedicalClaimMacro"
          element={<ProtectedRoute element={<ClaimMacro />} />}
        />
     
         <Route
          path="/SuperBill"
          element={<ProtectedRoute element={<SuperBill />} />}
        />
        <Route
          path="/GeneralDocuments/:id"
          element={<ProtectedRoute element={<GeneralDocuments />} />}
        />
     
        <Route
          path="/BillerPatientTracker/*"
          element={<ProtectedRoute element={<PatientTrackerTabs />} />}
        />
     
        <Route
          path="/InsurancePaymentReport"
          element={<ProtectedRoute element={<InsPaymentReport />} />}
        />
        <Route
          path="/RHMAgingRecievedCharges"
          element={<ProtectedRoute element={<AgingReport />} />}
        />
        <Route
          path="/ARAgingReportClaimDetails"
          element={<ProtectedRoute element={<ARClaimDetails />} />}
        />
        <Route
          path="/UpdateCPT"
          element={<ProtectedRoute element={<EditCpt />} />}
        />
        <Route
          path="/transactionlogs/:id"
          element={<ProtectedRoute element={<TransactionLogs />} />}
        />

        <Route
          path="/patient-dashboard/:id/*"
          element={<ProtectedRoute element={<PatDasboardNavigation />} />}
        />

          <Route
          path="/patientdashboard/:id/*"
          element={<ProtectedRoute element={<PatDashboard />} />}
        />
        <Route
          path="/patient-insurance/:id/*"
          element={<ProtectedRoute element={<PatientInsTab />} />}
        />

        <Route
          path="/workableclaims/*"
          element={<ProtectedRoute element={<TabNavigation />} />}
        />

        
        <Route
          path="/PatientContacts/:id/*"
          element={<ProtectedRoute element={<PatientContacts />} />}
        />

         <Route
          path="/CptReport"
          element={<ProtectedRoute element={<CPTReport />} />}
        />
        <Route
          path="/PatientStatementsWorkflow"
          element={<ProtectedRoute element={<PatientStatementsWorkflow />} />}
        />

        <Route
          path="/APIDebugTest"
          element={<APIDebugTest />}
        />

        {/* Remi diagnostics: probes every billing endpoint behind a Remi tool. */}
        <Route
          path="/RemiCoverage"
          element={<ProtectedRoute element={<RemiCoverageCheck />} />}
        />

         <Route
          path="/DenialManagement"
          element={<ProtectedRoute element={<DeniedDashboardPreview handleLogout={logout} />} />}
        />
       
         <Route
          path="/Fax"
          element={<ProtectedRoute element={<FaxDocuments />} />}
        />

        {/* Catch-all. React Router renders NOTHING for an unmatched path, so without this a
            stale link - an old bookmark, a renamed screen, a deep link from Remi built against
            a route that has since moved - produced a blank page with no error and no way back.
            Kept last: it only wins when every real route above has already failed to match. */}
        <Route
          path="*"
          element={<ProtectedRoute element={<ScreenNotFound />} />}
        />
      </Routes>
        </div>

        {/* Overlay-mode scrim. _sidebar.scss keeps it display:none above
            1024px, where the sidebar pushes instead of covering. */}
        {showShell && (
          <div className="hv-sidebar-scrim" onClick={closeSidebar} />
        )}
      </div>
    </RemiContextProvider>
  );
};

export default App;
